import React, { Component } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import styles from "assets/jss/material-kit-react/views/docPage.jsx";
import GlobalValue from "GlobalValue";
import { _callApiMessage, custonSort } from "GlobalFunction";
import E_Doc00 from "views/DocPage/Modal/E_Doc00.jsx";
import E_Doc01 from "views/DocPage/Modal/E_Doc01.jsx";
import E_Doc02 from "views/DocPage/Modal/E_Doc02.jsx";
import E_Doc00_insert from "views/DocPage/Modal/E_Doc02_insert.jsx";

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

let id = 0;
function createData(name, calories, fat, carbs, protein) {
  id += 1;
  return { id, name, calories, fat, carbs, protein };
}

class DocPage01_sub02 extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      Edocument: [],
      page: 0,
      rowsPerPage: 5,
      openEDoc: false,
      openEDoc_insert: false,
      EFile: [],
      EDoc: [],
      firstList: { firstEfile: [], firstEdoc: [] }
    };
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ page: 0, rowsPerPage: event.target.value });
  };
  componentDidMount() {
    this.setState({ Edocument: this.props.edocument });
  }

  handleEdocClose = () => {
    this.setState({ openEDoc: false, openEDoc_insert: false });
    this.props.initDocument("page2");
    // window.location.reload();
  };
  handleInsertBtn = () => {
    this.setState({ openEDoc_insert: true });
  };
  itemClicked = async item => {
    // console.log(item);
    if (item.EJSIGNGUBUN === 9 || item.EJSIGNGUBUN === 10) {
    } else {
      //확인날짜 업데이트
      var body = `SCDBName=${GlobalValue.USER_INFO.SCDBName}&SCHostIp=${
        GlobalValue.USER_INFO.SCHostIp
      }&EDDateTime=${item.EDDateTime}&EDMilliSecond=${
        item.EDMilliSecond
      }&STCode=${item.EDSTCode}&MYCode=${GlobalValue.USER_INFO.SUSTCode}`;

      await _callApiMessage("e-doc/updateOpenTime", body)
        .then(responsBody => {
          // console.log("e-doc/updateOpenTime", responsBody);
          if (responsBody !== undefined) {
            if (responsBody.message === "true") {
              // this.props._insertDoc(null);
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    }

    var body = `SCDBName=${GlobalValue.USER_INFO.SCDBName}&SCHostIp=${
      GlobalValue.USER_INFO.SCHostIp
    }&EDDateTime=${item.EDDateTime}&EDMilliSecond=${
      item.EDMilliSecond
    }&STCode=${item.EDSTCode}`;
    await _callApiMessage("e-doc/getEdoc/detail", body)
      .then(responsBody => {
        // console.log("e-doc/getEdoc/detail", responsBody);
        if (responsBody !== undefined) {
          if (responsBody.type !== "N") {
            var firstEFile = [];
            var firstEDoc = [];
            firstEDoc = responsBody.data.Edoc.filter(item => item.EJSeq === 0);
            // console.log("firstEDoc", firstEDoc);
            firstEFile = responsBody.data.EFile.filter(
              item => item.EFAddSTCode === firstEDoc[0].EDSTCode
            );

            this.setState({
              seletedItem: item,
              EFile: responsBody.data.EFile,
              EDoc: responsBody.data.Edoc,
              ERef: responsBody.data.ERef,
              firstList: { firstEFile, firstEDoc }
            });
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
    this.setState({ openEDoc: true });
    console.log(item);
  };
  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const Edocument = this.state.Edocument.filter(
      item =>
        item.ERSTCODE === GlobalValue.USER_INFO.SUSTCode &&
        item.EJSEQ === item.EDEJSeq &&
        item.EJSIGNGUBUN !== 10 &&
        item.EJSIGNGUBUN !== 9
    ).sort(custonSort);
    // console.log(Edocument);
    return (
      <Paper className={classes.root}>
        {this.state.seletedItem &&
          (this.state.seletedItem.EDEG1Code >= 100 &&
          this.state.seletedItem.EDEG1Code < 200 ? (
            <E_Doc00
              openDialog={this.state.openEDoc}
              gubun={3}
              handleEdocClose={this.handleEdocClose}
              EDoc={this.state.EDoc}
              EFile={this.state.EFile}
              ERef={this.state.ERef}
              firstList={this.state.firstList}
              item={this.state.seletedItem}
            />
          ) : this.state.seletedItem.EDEG1Code >= 200 &&
            this.state.seletedItem.EDEG1Code < 300 ? (
            <E_Doc01
              openDialog={this.state.openEDoc}
              gubun={3}
              handleEdocClose={this.handleEdocClose}
              EDoc={this.state.EDoc}
              EFile={this.state.EFile}
              ERef={this.state.ERef}
              firstList={this.state.firstList}
              item={this.state.seletedItem}
            />
          ) : this.state.seletedItem.EDEG1Code >= 300 &&
            this.state.seletedItem.EDEG1Code < 400 ? (
            <E_Doc02
              openDialog={this.state.openEDoc}
              gubun={3}
              handleEdocClose={this.handleEdocClose}
              EDoc={this.state.EDoc}
              EFile={this.state.EFile}
              ERef={this.state.ERef}
              firstList={this.state.firstList}
              item={this.state.seletedItem}
            />
          ) : null)}
        <E_Doc00_insert
          openDialog={this.state.openEDoc_insert}
          gubun={3}
          handleEdocClose={this.handleEdocClose}
          EDoc={this.state.EDoc}
          EFile={this.state.EFile}
          ERef={this.state.ERef}
          firstList={this.state.firstList}
        />
        <Table className={classes.table}>
          <TableHead>
            <TableRow flex="1">
              <CustomTableCell
                width="10%"
                className={classes.tableHeader}
                align="center"
              >
                구분
              </CustomTableCell>
              <CustomTableCell
                width="50%"
                className={classes.tableHeader}
                align="center"
              >
                제목
              </CustomTableCell>
              <CustomTableCell
                width="15%"
                className={classes.tableHeader}
                align="center"
              >
                기안일
              </CustomTableCell>
              <CustomTableCell
                width="12%"
                className={classes.tableHeader}
                align="center"
              >
                보낸 사람
              </CustomTableCell>
              <CustomTableCell
                width="13%"
                className={classes.tableHeader}
                align="center"
              >
                상태
              </CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Edocument.slice(
              page * rowsPerPage,
              page * rowsPerPage + rowsPerPage
            ).map((row, idx) => {
              return (
                <TableRow
                  className={classes.row}
                  key={idx}
                  onClick={() => this.itemClicked(row)}
                >
                  <CustomTableCell align="center">
                    {
                      GlobalValue.EG1Code_2.filter(
                        item => item.value === row.EDEG1Code
                      )[0].name
                    }
                  </CustomTableCell>
                  <CustomTableCell className={classes.tableText} align="left">
                    {row.EDTitle}
                  </CustomTableCell>
                  <CustomTableCell
                    className={classes.tableText}
                    component="th"
                    scope="row"
                    align="center"
                  >
                    {row.EDDateTime}
                  </CustomTableCell>
                  <CustomTableCell className={classes.tableText} align="center">
                    {row.EDSTCode === "!!!!!!!!!!"
                      ? "관리자"
                      : row.EJBEFJOINSTNAME}
                  </CustomTableCell>
                  <CustomTableCell className={classes.tableText} align="center">
                    {
                      GlobalValue.EJSignGubun_2.filter(
                        item => item.value === row.EJSIGNGUBUN
                      )[0].name
                    }
                  </CustomTableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                labelRowsPerPage="페이지 수"
                rowsPerPageOptions={[5, 10, 25]}
                colSpan={3}
                count={Edocument.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  native: true
                }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                // ActionsComponent={<TablePaginationActionsWrapped />}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  }
}

DocPage01_sub02.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DocPage01_sub02);
